export const GridIcon = () => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5 0.5H1.5C0.947715 0.5 0.5 0.947715 0.5 1.5V5C0.5 5.55228 0.947715 6 1.5 6H5C5.55228 6 6 5.55228 6 5V1.5C6 0.947715 5.55228 0.5 5 0.5Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.5 0.5H9C8.44771 0.5 8 0.947715 8 1.5V5C8 5.55228 8.44771 6 9 6H12.5C13.0523 6 13.5 5.55228 13.5 5V1.5C13.5 0.947715 13.0523 0.5 12.5 0.5Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.5 8H9C8.44772 8 8 8.44772 8 9V12.5C8 13.0523 8.44772 13.5 9 13.5H12.5C13.0523 13.5 13.5 13.0523 13.5 12.5V9C13.5 8.44772 13.0523 8 12.5 8Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5 8H1.5C0.947715 8 0.5 8.44772 0.5 9V12.5C0.5 13.0523 0.947715 13.5 1.5 13.5H5C5.55228 13.5 6 13.0523 6 12.5V9C6 8.44772 5.55228 8 5 8Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const ListIcon = () => {
    return (
        <svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.84619 1.89747C2.12942 1.89747 2.35902 1.66787 2.35902 1.38465C2.35902 1.10143 2.12942 0.871826 1.84619 0.871826C1.56297 0.871826 1.33337 1.10143 1.33337 1.38465C1.33337 1.66787 1.56297 1.89747 1.84619 1.89747Z"
                stroke="#9CA3AF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.43604 1.38452H14.6668"
                stroke="#9CA3AF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.84619 6.51295C2.12942 6.51295 2.35902 6.28335 2.35902 6.00013C2.35902 5.7169 2.12942 5.4873 1.84619 5.4873C1.56297 5.4873 1.33337 5.7169 1.33337 6.00013C1.33337 6.28335 1.56297 6.51295 1.84619 6.51295Z"
                stroke="#9CA3AF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.43604 6H14.6668"
                stroke="#9CA3AF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.84619 11.1282C2.12942 11.1282 2.35902 10.8985 2.35902 10.6154C2.35902 10.3322 2.12942 10.1025 1.84619 10.1025C1.56297 10.1025 1.33337 10.3322 1.33337 10.6154C1.33337 10.8985 1.56297 11.1282 1.84619 11.1282Z"
                stroke="#9CA3AF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.43604 10.6155H14.6668"
                stroke="#9CA3AF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const ProjectIcon = () => {
    return (
        <svg
            width="18"
            height="20"
            viewBox="0 0 18 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.1428 0.714111H6.85704C6.06807 0.714111 5.42847 1.3537 5.42847 2.14268V2.85697C5.42847 3.64594 6.06807 4.28554 6.85704 4.28554H11.1428C11.9317 4.28554 12.5713 3.64594 12.5713 2.85697V2.14268C12.5713 1.3537 11.9317 0.714111 11.1428 0.714111Z"
                stroke="white"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.9286 2.14282H15.0714C15.4503 2.14282 15.8137 2.29334 16.0816 2.56124C16.3494 2.82915 16.5 3.19251 16.5 3.57139V17.8571C16.5 18.236 16.3494 18.5994 16.0816 18.8672C15.8137 19.1351 15.4503 19.2857 15.0714 19.2857H2.92857C2.54969 19.2857 2.18633 19.1351 1.91841 18.8672C1.65051 18.5994 1.5 18.236 1.5 17.8571V3.57139C1.5 3.19251 1.65051 2.82915 1.91841 2.56124C2.18633 2.29334 2.54969 2.14282 2.92857 2.14282H5.07143"
                stroke="white"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const MappingIcon = () => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.125 18V16.5H5.625V18H4.125ZM8.25 18V16.5H9.75V18H8.25ZM12.375 18V16.5H13.875V18H12.375ZM16.5 18V16.5H18V18H16.5ZM16.5 13.875V12.375H18V13.875H16.5ZM16.5 9.75V8.25H18V9.75H16.5ZM16.5 5.625V4.125H18V5.625H16.5ZM0 18V0H18V1.5H1.5V18H0Z"
                fill="#CCCCCC"
            />
        </svg>
    );
};

export const MatrixIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.823 21.4984V2.50147C1.823 2.12675 2.12675 1.823 2.50147 1.823H21.4984C21.8731 1.823 22.1769 2.12675 22.1769 2.50147V21.4984C22.1769 21.8731 21.8731 22.1769 21.4984 22.1769H2.50147C2.12675 22.1769 1.823 21.8731 1.823 21.4984Z"
                stroke="#CCCCCC"
                strokeWidth="1.2"
            />
            <path
                d="M1.823 17.0884H22.1769"
                stroke="#CCCCCC"
                strokeWidth="1.2"
            />
            <path d="M1.823 12H22.1769" stroke="#CCCCCC" strokeWidth="1.2" />
            <path
                d="M22.1769 6.91162H1.823"
                stroke="#CCCCCC"
                strokeWidth="1.2"
            />
            <path d="M12 22.1769V1.823" stroke="#CCCCCC" strokeWidth="1.2" />
        </svg>
    );
};

export const DesignerIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2039_574)">
                <path
                    d="M19.375 15.6247L9.99969 18.75L0.625 15.6247V4.37469L9.99969 1.25L19.375 4.37469V15.6247Z"
                    stroke="#CCCCCC"
                    strokeWidth="1.2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.375 4.37476L9.99969 7.50007M9.99969 7.50007L0.625 4.37476M9.99969 7.50007V18.7501"
                    stroke="#CCCCCC"
                    strokeWidth="1.2"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2039_574">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const StyleIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_86_10016)">
                <path
                    d="M2.14293 0.714355H6.42864C6.80753 0.714355 7.17088 0.864865 7.4388 1.13277C7.7067 1.40068 7.85721 1.76404 7.85721 2.14293V15.7144C7.85721 16.6615 7.48094 17.5699 6.81117 18.2398C6.1414 18.9095 5.23298 19.2858 4.28578 19.2858C3.81678 19.2858 3.35237 19.1934 2.91906 19.0139C2.48576 18.8345 2.09204 18.5714 1.7604 18.2398C1.09063 17.5699 0.714355 16.6615 0.714355 15.7144V2.14293C0.714355 1.76404 0.864865 1.40068 1.13277 1.13277C1.40068 0.864865 1.76404 0.714355 2.14293 0.714355Z"
                    stroke="#CCCCCC"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.85731 7.14296L12.8573 2.11439C13.125 1.84832 13.487 1.69897 13.8645 1.69897C14.2419 1.69897 14.604 1.84832 14.8716 2.11439L17.8859 5.14296C18.152 5.41062 18.3013 5.7727 18.3013 6.1501C18.3013 6.52752 18.152 6.88959 17.8859 7.15725L6.81445 18.243"
                    stroke="#CCCCCC"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.8573 12.1428H17.8573C18.2362 12.1428 18.5996 12.2933 18.8675 12.5612C19.1353 12.8292 19.2859 13.1925 19.2859 13.5714V17.8571C19.2859 18.236 19.1353 18.5994 18.8675 18.8673C18.5996 19.1351 18.2362 19.2857 17.8573 19.2857H4.28589"
                    stroke="#CCCCCC"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M0.714355 6.42847H7.85721"
                    stroke="#CCCCCC"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M0.714355 12.1428H7.85721"
                    stroke="#CCCCCC"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_86_10016">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const DetailsIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_86_10001)">
                <path
                    d="M0.714355 1.42847H19.2858"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M0.714355 5.71436H15.0001"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M0.714355 10H10.7144"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M0.714355 18.5715H19.2858"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M0.714355 14.2856H15.0001"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_86_10001">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const PdfIcon = () => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.69462 0H24L36 12V34.7926C36 37.6711 33.5088 40 30.4403 40H9.57031C6.49114 40 4 37.6711 4 34.7926V5.20733C3.99995 2.32878 6.61539 0 9.69462 0Z"
                fill="#D92D20"
            />
            <path
                d="M24.0257 8.16V0L36 12H28.0171C24.4248 12 23.8593 9.44 24.0257 8.16Z"
                fill="white"
                fillOpacity="0.3"
            />
            <path
                d="M24.124 32V25.4546H28.4578V26.5956H25.5079V28.1552H28.1702V29.2962H25.5079V32H24.124Z"
                fill="white"
            />
            <path
                d="M19.8965 32H17.5762V25.4546H19.9157C20.574 25.4546 21.1408 25.5856 21.6159 25.8477C22.0911 26.1076 22.4565 26.4816 22.7122 26.9695C22.97 27.4574 23.0989 28.0412 23.0989 28.7209C23.0989 29.4027 22.97 29.9887 22.7122 30.4787C22.4565 30.9688 22.089 31.3449 21.6096 31.6069C21.1323 31.869 20.5613 32 19.8965 32ZM18.96 30.8143H19.839C20.248 30.8143 20.5922 30.7419 20.8713 30.597C21.1525 30.45 21.3635 30.2231 21.5041 29.9162C21.6468 29.6073 21.7182 29.2089 21.7182 28.7209C21.7182 28.2373 21.6468 27.842 21.5041 27.5352C21.3635 27.2284 21.1536 27.0025 20.8745 26.8576C20.5953 26.7128 20.2512 26.6403 19.8422 26.6403H18.96V30.8143Z"
                fill="white"
            />
            <path
                d="M11.749 32V25.4546H14.3314C14.8279 25.4546 15.2508 25.5494 15.6002 25.739C15.9497 25.9265 16.216 26.1875 16.3992 26.5221C16.5846 26.8544 16.6773 27.238 16.6773 27.6726C16.6773 28.1073 16.5835 28.4908 16.396 28.8232C16.2085 29.1556 15.9369 29.4145 15.5811 29.5998C15.2274 29.7852 14.7991 29.8779 14.2963 29.8779H12.6503V28.7689H14.0725C14.3389 28.7689 14.5583 28.7231 14.7309 28.6314C14.9056 28.5377 15.0356 28.4088 15.1208 28.2447C15.2082 28.0785 15.2519 27.8878 15.2519 27.6726C15.2519 27.4553 15.2082 27.2657 15.1208 27.1037C15.0356 26.9397 14.9056 26.8129 14.7309 26.7234C14.5562 26.6318 14.3346 26.586 14.0661 26.586H13.1329V32H11.749Z"
                fill="white"
            />
        </svg>
    );
};

export const SpaceIcon = () => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M28.9745 36.6666H11.0258C6.77747 36.6666 3.3335 33.2227 3.3335 28.9743L3.3335 11.0256C3.3335 6.77723 6.77747 3.33325 11.0258 3.33325L28.9745 3.33325C33.223 3.33325 36.6668 6.77723 36.6668 11.0256V28.9743C36.6668 33.2227 33.223 36.6666 28.9745 36.6666Z"
                stroke="black"
                strokeWidth="2.24359"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.3887 28.6116L29.3374 10.6628"
                stroke="black"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M30.2439 17.4171V10.1648H22.9915"
                stroke="black"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.1646 22.9915V30.2438H17.4169"
                stroke="black"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const CustomIcon = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18.2437 12.0089L16.1233 18.3696C16.0545 18.5763 15.8891 18.7364 15.6803 18.7985L2.68519 22.6618C2.16741 22.8156 1.69069 22.3232 1.86151 21.8107L6.08072 9.15317C6.14204 8.96904 6.28051 8.82073 6.45994 8.74686L12.4542 6.27861C12.7035 6.17595 12.9901 6.23323 13.1807 6.42383L18.0823 11.3255C18.2611 11.5044 18.3236 11.769 18.2437 12.0089Z"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.24219 22.2403L9.32425 15.1582"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.3734 11.6175L21.5211 8.46996C22.3902 7.60071 22.3902 6.19156 21.5211 5.3224L19.1605 2.96168C18.2912 2.09253 16.882 2.09253 16.0128 2.96168L12.8652 6.10924"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6856 12.7977C11.0337 12.1459 9.97673 12.1459 9.32489 12.7977C8.67295 13.4497 8.67295 14.5066 9.32489 15.1584C9.97673 15.8103 11.0337 15.8103 11.6856 15.1584C12.3374 14.5066 12.3374 13.4497 11.6856 12.7977Z"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const RectangleIcon = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.76953 21.1147V3.88491C2.76953 3.54506 3.04506 3.26953 3.38491 3.26953H20.6147C20.9545 3.26953 21.23 3.54506 21.23 3.88491V21.1147C21.23 21.4545 20.9545 21.73 20.6147 21.73H3.38491C3.04506 21.73 2.76953 21.4545 2.76953 21.1147Z"
                stroke="black"
                strokeWidth="1.2"
            />
            <path
                d="M2.76967 4.2953C3.33611 4.2953 3.7953 3.83611 3.7953 3.26967C3.7953 2.70323 3.33611 2.24414 2.76967 2.24414C2.20323 2.24414 1.74414 2.70323 1.74414 3.26967C1.74414 3.83611 2.20323 4.2953 2.76967 4.2953Z"
                fill="black"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.2307 22.7557C21.7971 22.7557 22.2562 22.2967 22.2562 21.7302C22.2562 21.1638 21.7971 20.7046 21.2307 20.7046C20.6643 20.7046 20.2051 21.1638 20.2051 21.7302C20.2051 22.2967 20.6643 22.7557 21.2307 22.7557Z"
                fill="black"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const DoorIcon = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_115_13894)">
                <path
                    d="M16.0255 13H15"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 2H19.4666C19.7612 2 20 2.29542 20 2.65993V23.3401C20 23.7046 19.7612 24 19.4666 24H12M12 2H4.53335C4.23881 2 4 2.29542 4 2.65993V23.3401C4 23.7046 4.23881 24 4.53335 24H12"
                    stroke="black"
                    strokeWidth="1.2"
                />
                <path
                    d="M1 24H23"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_115_13894">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const WindowIcon = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.0012 2.323H21.4996C21.8743 2.323 22.1781 2.62675 22.1781 3.00147V21.9984C22.1781 22.3731 21.8743 22.6769 21.4996 22.6769H12.0012M12.0012 2.323H2.50269C2.12797 2.323 1.82422 2.62675 1.82422 3.00147V21.9984C1.82422 22.3731 2.12797 22.6769 2.50269 22.6769H12.0012M12.0012 2.323V22.6769"
                stroke="black"
                strokeWidth="1.2"
            />
        </svg>
    );
};

export const ObstacleIcon = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.43618 8.93613L12 12.5M12 12.5L15.5638 16.0638M12 12.5L15.5638 8.93613M12 12.5L8.43618 16.0638"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.69992 2.41992H1.91992V6.19992"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.91992 11.2397V13.7597"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.7402 2.41992H13.2602"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.7402 22.5801H13.2602"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.0801 11.2397V13.7597"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.3008 2.41992H22.0808V6.19992"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.69992 22.5798H1.91992V18.7998"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.3008 22.5798H22.0808V18.7998"
                stroke="black"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const SingleDoorIcon = () => {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2145_30000)">
                <path
                    d="M16.3588 13H15.3333"
                    stroke="#F5F5F5"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.4993 2H18.566C18.8053 2 18.9993 2.29542 18.9993 2.65993V23.3401C18.9993 23.7046 18.8053 24 18.566 24H12.4993M12.4993 2H6.43268C6.19336 2 5.99933 2.29542 5.99933 2.65993V23.3401C5.99933 23.7046 6.19336 24 6.43268 24H12.4993"
                    stroke="#F5F5F5"
                    strokeWidth="1.5"
                />
                <path
                    d="M1.33331 24H23.3333"
                    stroke="#F5F5F5"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2145_30000">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0.333313 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const DoubleDoorIcon = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2145_30008)">
                <path
                    d="M20.0255 13H19"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.02553 13H4"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.5 2H11.6333C11.8358 2 12 2.29542 12 2.65993V23.3401C12 23.7046 11.8358 24 11.6333 24H6.5M6.5 2H1.36668C1.16418 2 1 2.29542 1 2.65993V23.3401C1 23.7046 1.16418 24 1.36668 24H6.5"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path
                    d="M17.5 2H22.6333C22.8358 2 23 2.29542 23 2.65993V23.3401C23 23.7046 22.8358 24 22.6333 24H17.5M17.5 2H12.3667C12.1642 2 12 2.29542 12 2.65993V23.3401C12 23.7046 12.1642 24 12.3667 24H17.5"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path
                    d="M1 24H23"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2145_30008">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const SlidingDoorIcon = () => {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2145_30018)">
                <path
                    d="M21.0243 13H19.9988"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.99878 2H12.5988C12.8197 2 12.9988 2.29542 12.9988 2.65993V23.3401C12.9988 23.7046 12.8197 24 12.5988 24H6.99878M6.99878 2H1.3988C1.17788 2 0.998779 2.29542 0.998779 2.65993V23.3401C0.998779 23.7046 1.17788 24 1.3988 24H6.99878"
                    stroke="black"
                    strokeWidth="1.2"
                />
                <path
                    d="M16.4988 2H23.4988C23.7749 2 23.9988 2.29542 23.9988 2.65993V23.3401C23.9988 23.7046 23.7749 24 23.4988 24H16.4988M16.4988 2H9.4988C9.22266 2 8.99878 2.29542 8.99878 2.65993V23.3401C8.99878 23.7046 9.22266 24 9.4988 24H16.4988"
                    stroke="black"
                    strokeWidth="1.2"
                />
                <path
                    d="M6.99878 2H8.86544C8.93908 2 8.99878 2.29542 8.99878 2.65993V23.3401C8.99878 23.7046 8.93908 24 8.86544 24H6.99878M6.99878 2H5.13212C5.05848 2 4.99878 2.29542 4.99878 2.65993V23.3401C4.99878 23.7046 5.05848 24 5.13212 24H6.99878"
                    stroke="black"
                    strokeWidth="1.2"
                />
                <path
                    d="M1.66675 24H23.6667"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2145_30018">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0.666748 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const DoorwayIcon = () => {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2145_30050)">
                <path
                    d="M12.8328 2H18.8994C19.1387 2 19.3328 2.29542 19.3328 2.65993V23.3401C19.3328 23.7046 19.1387 24 18.8994 24H12.8328M12.8328 2H6.76611C6.52679 2 6.33276 2.29542 6.33276 2.65993V23.3401C6.33276 23.7046 6.52679 24 6.76611 24H12.8328"
                    stroke="black"
                    strokeWidth="1.2"
                />
                <path
                    d="M1.66675 24H23.6667"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2145_30050">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0.666748 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const EditIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2145_21474)">
                <path
                    d="M6 14.2399L1.5 15.4999L2.76 10.9999L11 2.7999C11.0931 2.70465 11.2044 2.62897 11.3271 2.57731C11.4499 2.52564 11.5818 2.49902 11.715 2.49902C11.8482 2.49902 11.9801 2.52564 12.1029 2.57731C12.2256 2.62897 12.3369 2.70465 12.43 2.7999L14.2 4.5799C14.2937 4.67286 14.3681 4.78347 14.4189 4.90532C14.4697 5.02718 14.4958 5.15789 14.4958 5.2899C14.4958 5.42191 14.4697 5.55262 14.4189 5.67448C14.3681 5.79634 14.2937 5.90694 14.2 5.9999L6 14.2399Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2145_21474">
                    <rect
                        width="14"
                        height="14"
                        fill="white"
                        transform="translate(1 2)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const DeleteIcon = () => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.4698 6.44873L12.1058 14.2065C11.9908 14.8603 11.4228 15.3371 10.759 15.3371H5.24102C4.57715 15.3371 4.00921 14.8603 3.89427 14.2065L2.53027 6.44873"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.1537 4.39747H10.3077M10.3077 4.39747V3.03004C10.3077 2.27479 9.69556 1.6626 8.94031 1.6626H7.06005C6.30487 1.6626 5.69262 2.27479 5.69262 3.03004V4.39747M10.3077 4.39747H5.69262M1.84668 4.39747H5.69262"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const FitScreenIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.0002 10L22.0799 1.91992M22.0799 1.91992V6.95992M22.0799 1.91992H17.0399"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.49995 14.5L1.91992 22.0801M1.91992 22.0801V17.0401M1.91992 22.0801H6.95992"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const SnappingIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2145_23906)">
                <path
                    d="M2.31018 2.67992C1.96227 2.67992 1.68018 2.39783 1.68018 2.04992C1.68018 1.70202 1.96227 1.41992 2.31018 1.41992C2.65808 1.41992 2.94018 1.70202 2.94018 2.04992C2.94018 2.39783 2.65808 2.67992 2.31018 2.67992Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.31018 7.93969C1.96227 7.93969 1.68018 7.65759 1.68018 7.30969C1.68018 6.96178 1.96227 6.67969 2.31018 6.67969C2.65808 6.67969 2.94018 6.96178 2.94018 7.30969C2.94018 7.65759 2.65808 7.93969 2.31018 7.93969Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.31018 13.1999C1.96227 13.1999 1.68018 12.9178 1.68018 12.5699C1.68018 12.222 1.96227 11.9399 2.31018 11.9399C2.65808 11.9399 2.94018 12.222 2.94018 12.5699C2.94018 12.9178 2.65808 13.1999 2.31018 13.1999Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.31018 18.4602C1.96227 18.4602 1.68018 18.1781 1.68018 17.8302C1.68018 17.4823 1.96227 17.2002 2.31018 17.2002C2.65808 17.2002 2.94018 17.4823 2.94018 17.8302C2.94018 18.1781 2.65808 18.4602 2.31018 18.4602Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.56994 2.67992C7.22204 2.67992 6.93994 2.39783 6.93994 2.04992C6.93994 1.70202 7.22204 1.41992 7.56994 1.41992C7.91785 1.41992 8.19994 1.70202 8.19994 2.04992C8.19994 2.39783 7.91785 2.67992 7.56994 2.67992Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.56994 7.93969C7.22204 7.93969 6.93994 7.65759 6.93994 7.30969C6.93994 6.96178 7.22204 6.67969 7.56994 6.67969C7.91785 6.67969 8.19994 6.96178 8.19994 7.30969C8.19994 7.65759 7.91785 7.93969 7.56994 7.93969Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.56994 13.1999C7.22204 13.1999 6.93994 12.9178 6.93994 12.5699C6.93994 12.222 7.22204 11.9399 7.56994 11.9399C7.91785 11.9399 8.19994 12.222 8.19994 12.5699C8.19994 12.9178 7.91785 13.1999 7.56994 13.1999Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.56994 18.4602C7.22204 18.4602 6.93994 18.1781 6.93994 17.8302C6.93994 17.4823 7.22204 17.2002 7.56994 17.2002C7.91785 17.2002 8.19994 17.4823 8.19994 17.8302C8.19994 18.1781 7.91785 18.4602 7.56994 18.4602Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.8297 2.67992C12.4818 2.67992 12.1997 2.39783 12.1997 2.04992C12.1997 1.70202 12.4818 1.41992 12.8297 1.41992C13.1776 1.41992 13.4597 1.70202 13.4597 2.04992C13.4597 2.39783 13.1776 2.67992 12.8297 2.67992Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.13 2.67992C17.7821 2.67992 17.5 2.39783 17.5 2.04992C17.5 1.70202 17.7821 1.41992 18.13 1.41992C18.4779 1.41992 18.76 1.70202 18.76 2.04992C18.76 2.39783 18.4779 2.67992 18.13 2.67992Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.8297 7.93969C12.4818 7.93969 12.1997 7.65759 12.1997 7.30969C12.1997 6.96178 12.4818 6.67969 12.8297 6.67969C13.1776 6.67969 13.4597 6.96178 13.4597 7.30969C13.4597 7.65759 13.1776 7.93969 12.8297 7.93969Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.13 7.93969C17.7821 7.93969 17.5 7.65759 17.5 7.30969C17.5 6.96178 17.7821 6.67969 18.13 6.67969C18.4779 6.67969 18.76 6.96178 18.76 7.30969C18.76 7.65759 18.4779 7.93969 18.13 7.93969Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.8297 13.1999C12.4818 13.1999 12.1997 12.9178 12.1997 12.5699C12.1997 12.222 12.4818 11.9399 12.8297 11.9399C13.1776 11.9399 13.4597 12.222 13.4597 12.5699C13.4597 12.9178 13.1776 13.1999 12.8297 13.1999Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.13 13.1999C17.7821 13.1999 17.5 12.9178 17.5 12.5699C17.5 12.222 17.7821 11.9399 18.13 11.9399C18.4779 11.9399 18.76 12.222 18.76 12.5699C18.76 12.9178 18.4779 13.1999 18.13 13.1999Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.8297 18.4602C12.4818 18.4602 12.1997 18.1781 12.1997 17.8302C12.1997 17.4823 12.4818 17.2002 12.8297 17.2002C13.1776 17.2002 13.4597 17.4823 13.4597 17.8302C13.4597 18.1781 13.1776 18.4602 12.8297 18.4602Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.13 18.4602C17.7821 18.4602 17.5 18.1781 17.5 17.8302C17.5 17.4823 17.7821 17.2002 18.13 17.2002C18.4779 17.2002 18.76 17.4823 18.76 17.8302C18.76 18.1781 18.4779 18.4602 18.13 18.4602Z"
                    fill="black"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2145_23906">
                    <rect
                        width="19"
                        height="19"
                        fill="white"
                        transform="translate(0.5 0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const DimensionIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 8.25V15.75M12 8.25H8.25M12 8.25H15.75"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.4375 13.4062V18.5625C20.4375 19.5981 19.5981 20.4375 18.5625 20.4375H5.4375C4.40197 20.4375 3.5625 19.5981 3.5625 18.5625V13.4062M20.4375 10.5938V5.4375C20.4375 4.40197 19.5981 3.5625 18.5625 3.5625H5.4375C4.40197 3.5625 3.5625 4.40197 3.5625 5.4375V10.5938"
                stroke="black"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M19.0312 13.4062V10.5938H21.8438V13.4062H19.0312Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M2.15625 13.4062V10.5938H4.96875V13.4062H2.15625Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const AboveIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2145_32288)">
                <path
                    d="M1.16156 13.6533L14.8359 13.6533"
                    stroke="black"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    d="M2 9V5.66667C2 4.74615 2.76754 4 3.71427 4H12.2857C13.2325 4 14 4.74615 14 5.66667V9"
                    stroke="black"
                />
                <path
                    d="M8.35355 5.64645C8.15829 5.45118 7.84171 5.45118 7.64645 5.64645L4.46447 8.82843C4.2692 9.02369 4.2692 9.34027 4.46447 9.53553C4.65973 9.7308 4.97631 9.7308 5.17157 9.53553L8 6.70711L10.8284 9.53553C11.0237 9.7308 11.3403 9.7308 11.5355 9.53553C11.7308 9.34027 11.7308 9.02369 11.5355 8.82843L8.35355 5.64645ZM8 6L7.5 6L7.5 12L8 12L8.5 12L8.5 6L8 6Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_2145_32288">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(16 0.5) rotate(90)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const BelowIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2145_32299)">
                <path
                    d="M14.8384 3.34668L1.16406 3.34668"
                    stroke="black"
                    strokeLinecap="square"
                    strokeLinejoin="round"
                />
                <path
                    d="M14 8L14 11.3333C14 12.2539 13.2325 13 12.2857 13L3.71427 13C2.76754 13 2 12.2539 2 11.3333L2 8"
                    stroke="black"
                />
                <path
                    d="M7.64645 11.3536C7.84171 11.5488 8.15829 11.5488 8.35355 11.3536L11.5355 8.17157C11.7308 7.97631 11.7308 7.65973 11.5355 7.46447C11.3403 7.2692 11.0237 7.2692 10.8284 7.46447L8 10.2929L5.17157 7.46447C4.97631 7.2692 4.65973 7.2692 4.46447 7.46447C4.2692 7.65973 4.2692 7.97631 4.46447 8.17157L7.64645 11.3536ZM8 11L8.5 11L8.5 5L8 5L7.5 5L7.5 11L8 11Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_2145_32299">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0 16.5) rotate(-90)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const DuplicateIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.2165 15.22H5.98447C5.70609 15.22 5.48047 14.9944 5.48047 14.716V6.48398C5.48047 6.20561 5.70609 5.97998 5.98447 5.97998H14.2165C14.4948 5.97998 14.7205 6.20561 14.7205 6.48398V14.716C14.7205 14.9944 14.4948 15.22 14.2165 15.22Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5193 5.97978V2.28379C10.5193 2.00541 10.2937 1.77979 10.0153 1.77979H1.7833C1.50492 1.77979 1.2793 2.00541 1.2793 2.28379V10.5158C1.2793 10.7942 1.50492 11.0198 1.7833 11.0198H5.4793"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const DeleteIconSm = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.4698 6.44873L12.1058 14.2065C11.9908 14.8603 11.4228 15.3371 10.759 15.3371H5.24102C4.57715 15.3371 4.00921 14.8603 3.89427 14.2065L2.53027 6.44873"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.1537 4.39747H10.3077M10.3077 4.39747V3.03004C10.3077 2.27479 9.69556 1.6626 8.94031 1.6626H7.06005C6.30487 1.6626 5.69262 2.27479 5.69262 3.03004V4.39747M10.3077 4.39747H5.69262M1.84668 4.39747H5.69262"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const InternalWallIcon = () => {
    return (
        <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.57617 13.7887H50.4262M50.4262 26.0012H1.57617M1.57617 38.2137H50.4262M16.8418 1.57617V13.7887M32.1074 13.7887V26.0012M13.7887 26.0012V38.2137M38.2137 26.0012V38.2137M22.948 38.2137V50.4262M1.57617 7.68242C1.57617 6.06294 2.21951 4.50979 3.36465 3.36465C4.50979 2.21951 6.06294 1.57617 7.68242 1.57617H44.3199C45.9394 1.57617 47.4925 2.21951 48.6377 3.36465C49.7828 4.50979 50.4262 6.06294 50.4262 7.68242V44.3199C50.4262 45.9394 49.7828 47.4925 48.6377 48.6377C47.4925 49.7828 45.9394 50.4262 44.3199 50.4262H7.68242C6.06294 50.4262 4.50979 49.7828 3.36465 48.6377C2.21951 47.4925 1.57617 45.9394 1.57617 44.3199V7.68242Z"
                stroke="#1C1C1E"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const CalibrateIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.99959 13.777C10.914 13.777 13.2765 11.4145 13.2765 8.50008C13.2765 5.58571 10.914 3.22314 7.99959 3.22314C5.08522 3.22314 2.72266 5.58571 2.72266 8.50008C2.72266 11.4145 5.08522 13.777 7.99959 13.777Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 13.7769V15.2845"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.72253 8.5H1.21484"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 3.22302V1.71533"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.2773 8.5H14.785"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const ExtractIcon = () => {
    return (
        <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.2793 11.8626L1.28767 11.8533"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.2793 15.2205L1.28767 15.2112"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.2793 5.14676L1.28767 5.13745"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.2793 1.78885L1.28767 1.77954"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M1.2793 8.50467L1.28767 8.49536"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.63867 15.2205L4.64705 15.2112"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.99609 15.2205L8.00447 15.2112"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.3535 15.2205L11.3619 15.2112"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.7109 15.2205L14.7193 15.2112"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.7109 11.8626L14.7193 11.8533"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.7109 8.50467L14.7193 8.49536"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.7109 5.14676L14.7193 5.13745"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.7109 1.78885L14.7193 1.77954"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.3535 1.78885L11.3619 1.77954"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.99609 1.78885L8.00447 1.77954"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.63867 1.78885L4.64705 1.77954"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.63867 11.8542V5.13843H11.3544V11.8542H4.63867Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const UnitIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.2617 21.4983V14.9398C14.2617 14.5651 14.5655 14.2614 14.9402 14.2614H21.4987C21.8734 14.2614 22.1771 14.5651 22.1771 14.9398V21.4983C22.1771 21.873 21.8734 22.1768 21.4987 22.1768H14.9402C14.5655 22.1768 14.2617 21.873 14.2617 21.4983Z"
                stroke="black"
                strokeWidth="1.5"
            />
            <path
                d="M1.82812 21.4983V14.9398C1.82812 14.5651 2.13188 14.2614 2.50659 14.2614H9.06506C9.43978 14.2614 9.74353 14.5651 9.74353 14.9398V21.4983C9.74353 21.873 9.43978 22.1768 9.06506 22.1768H2.50659C2.13188 22.1768 1.82812 21.873 1.82812 21.4983Z"
                stroke="black"
                strokeWidth="1.5"
            />
            <path
                d="M14.2617 9.05994V2.50147C14.2617 2.12675 14.5655 1.823 14.9402 1.823H21.4987C21.8734 1.823 22.1771 2.12675 22.1771 2.50147V9.05994C22.1771 9.43465 21.8734 9.7384 21.4987 9.7384H14.9402C14.5655 9.7384 14.2617 9.43465 14.2617 9.05994Z"
                stroke="black"
                strokeWidth="1.5"
            />
            <path
                d="M1.82812 9.05994V2.50147C1.82812 2.12675 2.13188 1.823 2.50659 1.823H9.06506C9.43978 1.823 9.74353 2.12675 9.74353 2.50147V9.05994C9.74353 9.43465 9.43978 9.7384 9.06506 9.7384H2.50659C2.13188 9.7384 1.82812 9.43465 1.82812 9.05994Z"
                stroke="black"
                strokeWidth="1.5"
            />
        </svg>
    );
};
